import { models } from "types/api/viewModels";
import { UnavailableDataPlaceholderText } from "../constants/text.ts";

export const calculateCubePercentage = (
	cubeCount: number | null | undefined,
	cubeCapacity: number | null | undefined
): number => {
	if ((!cubeCount && cubeCount !== 0) || (!cubeCapacity && cubeCapacity !== 0) || cubeCount < 0 || cubeCapacity <= 0)
		return 0;
	return (cubeCount / cubeCapacity) * 100;
};

export const calculateRemainingCubes = (
	cubeCount: number | null | undefined,
	cubeCapacity: number | null | undefined
): string => {
	if ((!cubeCount && cubeCount !== 0) || (!cubeCapacity && cubeCapacity !== 0)) return UnavailableDataPlaceholderText;
	const remainingCubes = cubeCapacity - cubeCount;
	return `${remainingCubes.toFixed(2).replace(/[.,]00$/, "")}/${cubeCapacity}`;
};

export const calculateRemainingCubesForExcel = (
	cubeCount: number | null | undefined,
	cubeCapacity: number | null | undefined
): string => {
	if ((!cubeCount && cubeCount !== 0) || (!cubeCapacity && cubeCapacity !== 0)) return UnavailableDataPlaceholderText;
	const remainingCubes = cubeCapacity - cubeCount;
	return `${remainingCubes.toFixed(2).replace(/[.,]00$/, "")}`;
};

export const findAndReturnBillToInfoFromDraft = (
	draft: models["DraftOrderViewModel"],
	billTos: models["BillToViewModel"][]
) => billTos?.find((billTo) => billTo.billToId === draft?.configurations?.[0]?.billToId);
